import main from "../main";

function addLineListener() {
  removeLineListener();
  if (process.env.VUE_APP_PROJECT === "customer") return;
  window.addEventListener("online", updateOnlineStatus);
  window.addEventListener("offline", updateOnlineStatus);
}

function removeLineListener() {
  window.removeEventListener("online", updateOnlineStatus);
  window.removeEventListener("offline", updateOnlineStatus);
}

function updateOnlineStatus(e, reloadPage = () => window.location.reload()) {
  // Customer lifecycle events are owned by historyReconcileManager so online,
  // focus, visibility and pageshow cannot create competing retry loops.
  if (process.env.VUE_APP_PROJECT === "customer") return;

  const vueMachine = main.getVueMachine();
  const store = vueMachine && vueMachine.store;
  if (!store || !store.state || !store.state.ws) return;

  const { type } = e;
  const onLine = type === "online";

  if (!onLine || !store.state.ws.isReconnect) return;

  reloadPage();
}

addLineListener();

export default {
  addLineListener,
  removeLineListener,
  updateOnlineStatus
};
